import { ENABLE_LCA_FACILITIES_PROTOTYPE_UI } from "../../../config/constants";
import FacilityRegisterDrawer from "../facilityDrawer/FacilityRegisterDrawer";
import { FacilityRegisterModalProps } from "../facilityDrawer/types/facilityDrawer.types";
import FacilityRegisterModalLegacy from "./legacy/FacilityRegisterModalLegacy";

const FacilityRegisterModal = (props: FacilityRegisterModalProps) =>
  ENABLE_LCA_FACILITIES_PROTOTYPE_UI ? (
    <FacilityRegisterDrawer {...props} />
  ) : (
    <FacilityRegisterModalLegacy {...props} />
  );

export default FacilityRegisterModal;
export type { FacilityRegisterModalProps };
